import React from "react";
import styled from "styled-components";

const ContainerStyle = styled.div`
  width: 100%;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1140px;
  }
  @media (min-width: 1400px) {
    max-width: 2000px;
  }
`;

export const Container = (props) => {
  if (props.main)
    return (
      <ContainerStyle
        {...props}
        style={{ paddingTop: "2rem", paddingBottom: "2rem" }}
      >
        {props.children}
      </ContainerStyle>
    );
  return <ContainerStyle {...props}>{props.children}</ContainerStyle>;
};
